// ***************************************
// themeController
//
// Each game must include a theme controller that contains methods related to the visual theme. 
// These methods are called by the flow controller that also created the object.
//
// This version is just a template.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 12-10-2015
// ***************************************
import { tgfSettings } from "../../game_logic/framework/tgfSettings";
import { themeSettings } from "../settings/themeSettings";
// Directives for jslint
/*global tgfSettings */
/*global themeSettings */
// The constructor 
export var ThemeController = function () {
    "use strict";
    // Merge the settings into the total settings
    // When required settings can also be computed here and other initialization can take place
    tgfSettings.mergeSettings(themeSettings());
};
